import Swal from "sweetalert2";
import { deleteRoadRecording } from "../../../services/deleteRoadRecording";

export async function handleDeleteRecord(recording, relevantUrl, setRecords) {
    const deleteModal = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
    });
    if (!deleteModal.isConfirmed) return;

    Swal.fire({
        title: 'Deleting...',
        text: 'Please wait',
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
            Swal.showLoading();
        }
    });

    try {
        const deleted = await deleteRoadRecording(relevantUrl, recording.id);
        Swal.close();

        if (deleted && deleted.deletedRecording) {
            setRecords(prev => prev.filter(r => r.id !== recording.id));
            await Swal.fire('Deleted!', 'The recording has been deleted.', 'success');
        } else {
            console.error('Delete failed:', deleted);
            await Swal.fire('Error', deleted, 'error');
        }
    } catch (e) {
        Swal.close();
        console.error('Error deleting recording:', e);
        await Swal.fire('Error', 'Server error: could not delete', 'error');
    } 
};